import { useAccess } from '@hooks/useAccess';
import { useProjectParams } from '@hooks/useProjectParams';

import type React from 'react';
import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { ProjectStatusEnum } from '../../gql/graphql';
import { useProjectData } from '../../hooks/useProjectData';
import { DropdownContext } from '../DropdownContext';

export const KebabTreeCalculation: React.FC = () => {
    const navigate = useNavigate();
    const { id: projectId, methodology } = useProjectParams();
    const { calculation: calculationRules } = useAccess();

    const { projectData } = useProjectData(projectId, false);

    const onEditClick = useCallback(() => {
        navigate(`/projects/${methodology}/${projectId}/calculation/edit`);
    }, [methodology, navigate, projectId]);

    const items = useMemo(
        () => [
            {
                id: 2,
                label: 'Редактировать',
                action: onEditClick,
                disabled: projectData?.status === ProjectStatusEnum.Calculated,
            },
        ],
        [onEditClick, projectData?.status],
    );

    return projectData?.calculationNavigation?.data?.calculationNavData?.hasCalculation ? (
        <DropdownContext items={items} isDisabled={!calculationRules.canEdit} />
    ) : (
        <div />
    );
};

KebabTreeCalculation.displayName = 'KebabTreeCalculation';
